import React from 'react';
import { Container, wrap, Store } from 'AppReact';
import { SolidButton, CreditCard, Checkbox } from '../../../../common/molecules';
import { Description } from '../../../../common/atoms';
import { Label, BoldText } from './atoms';
import { InputError, Input, } from 'molecules';
import { GenericWrapper } from 'wrappers'
import { FieldWrapper, MarginY10 } from '../../../../common/wrappers';
import { calculateTotalFee } from '../../../../utils';
import { ContainerWrapper } from './wrappers';


const WrappedInput = wrap(Input, FieldWrapper);
const WrappedInputError = wrap(InputError, FieldWrapper);
const WrappedCheckbox = wrap(Checkbox, FieldWrapper);



const ModalBody = Container({
  name: 'ModalBody',
  props: { property: Store, cardDetails: Store, occupants: Store, termsModal: Store, leaseholderName: Store, termsAccepted: Store },
  elements: [
    {
      wrapper: ContainerWrapper,
      name: 'Container',
      elements: [
        {
          wrapper: GenericWrapper,
          name: 'CardSection',
          renderIf: ({ cardDetails, property, occupants }) => {
            const paidFee = calculateTotalFee(property, occupants, cardDetails.IsAdminFeePaid)
            return paidFee > 0;
          },
          elements: [
            {
              component: CreditCard,
              name: 'CreditCard',
              bindings: ({ cardDetails }) => ({ cardDetails }),
              displayValue: () => ''
            },
            {
              wrapper: MarginY10,
              name: 'CardSection',
              elements: [
                {
                  component: Label,
                  name: 'ApplicationFee',
                  bindings: ({ }) => ({}),
                  renderIf: ({ property }) => property?.application_fee,
                  displayValue: ({ property }) => `Application Fee: ${property.application_fee}`
                },
                {
                  component: Label,
                  name: 'AdminFee',
                  bindings: ({ }) => ({}),
                  renderIf: ({ property }) => property?.application_admin_fee,
                  displayValue: ({ property }) => `Admin Fee: ${property.application_admin_fee}`
                },
                {
                  component: Label,
                  name: 'AdditionalApplicantFee',
                  bindings: ({ }) => ({}),
                  renderIf: ({ property }) => property?.additional_applicant_fee,
                  displayValue: ({ property }) => `Additional Application Fee: ${property.additional_applicant_fee}`
                },
              ]
            },
          ],
        },
        {
          wrapper: GenericWrapper,
          name: 'InputFields',
          renderIf: ({ cardDetails, property, occupants }) => {
            const paidFee = calculateTotalFee(property, occupants, cardDetails.IsAdminFeePaid)
            return paidFee > 0;
          },
          elements: [
            {
              component: WrappedInput,
              name: 'Name',
              bindings: ({ cardDetails }) => ({ cardDetails, label: 'Name:', value: cardDetails.fullName })
            },
            {
              component: WrappedInputError,
              name: 'NameError',
              bindings: ({ cardDetails }) => ({ error: cardDetails.fullNameError }),
              renderIf: ({ cardDetails }) => !!cardDetails.fullNameError,
            },
            {
              component: WrappedInput,
              name: 'CardNumber',
              bindings: ({ cardDetails }) => ({ cardDetails, label: 'Card Number:', value: cardDetails.cardNumber })
            },
            {
              component: WrappedInputError,
              name: 'CardNumberError',
              bindings: ({ cardDetails }) => ({ error: cardDetails.cardNumberError }),
              renderIf: ({ cardDetails }) => !!cardDetails.cardNumberError,
            },
            {
              component: WrappedInput,
              name: 'Expiration',
              bindings: ({ cardDetails }) => ({ cardDetails, label: 'Expiration:', value: cardDetails.expiration })
            },
            {
              component: WrappedInputError,
              name: 'ExpirationError',
              bindings: ({ cardDetails }) => ({ error: cardDetails.expirationError }),
              renderIf: ({ cardDetails }) => !!cardDetails.expirationError,
            },
            {
              component: WrappedInput,
              name: 'CVV',
              bindings: ({ cardDetails }) => ({ cardDetails, label: 'CVV:', value: cardDetails.cardCode })
            },
            {
              component: WrappedInputError,
              name: 'CvvError',
              bindings: ({ cardDetails }) => ({ error: cardDetails.cardCodeError }),
              renderIf: ({ cardDetails }) => !!cardDetails.cardCodeError,
            },
            {
              component: WrappedInput,
              name: 'ZIP',
              bindings: ({ cardDetails }) => ({ cardDetails, label: 'ZIP:', value: cardDetails.zip })
            },
            {
              component: WrappedInputError,
              name: 'ZipError',
              bindings: ({ cardDetails }) => ({ error: cardDetails.zipError }),
              renderIf: ({ cardDetails }) => !!cardDetails.zipError,
            },
            {
              component: WrappedCheckbox,
              name: 'IsAdminFeePaid',
              renderIf: ({ property }) => property?.application_admin_fee,
              bindings: ({ cardDetails }) => ({ cardDetails, label: 'Pay Admin Fee now?', checked: cardDetails.IsAdminFeePaid })
            },
            {
              component: Description,
              name: 'Description',
              bindings: ({ }) => ({}),
              displayValue: () => `Complete applications (those submitted with payment of both the Application Fee and Administrative Fee) will be processed by our staff immediately upon receipt, resulting in the soonest possible move-in date for accepted applicants. All other applications will be processed in the order received, which may result in delays if information or documentation is missing.`
            },
            {
              component: BoldText,
              name: 'WarningInfo',
              bindings: ({ }) => ({}),
              displayValue: () => 'Fees paid are non-refundable.'
            },
          ]

        },
      ]
    },
    {
      component: SolidButton,
      name: 'Button',
      bindings: ({ cardDetails, property, occupants }) => {
        const paidFee = calculateTotalFee(property, occupants, cardDetails.IsAdminFeePaid)
        const title = paidFee <= 0 ? 'Submit Application' : `Pay $${paidFee}`
        return ({ cardDetails, paidFee, title, big: true, property})
      },
    },


  ]
})

export default ModalBody;
